import { Dialog, DialogContent } from "@mui/material";
import { Help, Info } from "@mui/icons-material";
import { useState } from "react";
import { BaseMenuGroup } from "./BaseMenuGroup";

export function HelpMenuGroup() {
  const [aboutOpen, setAboutOpen] = useState(false);
  const [whatIsOpen, setWhatIsOpen] = useState(false);

  return (
    <>
      <BaseMenuGroup
        title="Help"
        menuItems={[
          [
            {
              action: () => setWhatIsOpen(true),
              enabled: true,
              icon: <Info fontSize="small" />,
              title: "What Is Beardiface",
            },
            {
              action: () => setAboutOpen(true),
              enabled: true,
              icon: <Info fontSize="small" />,
              title: "About",
            },
          ],
          [
            {
              action: () => window.open("docs"),
              enabled: true,
              icon: <Help fontSize="small" />,
              title: "Documentation",
            },
          ],
        ]}
      />
      <Dialog
        open={whatIsOpen}
        onClose={() => setWhatIsOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <iframe
          title="What is Beardiface"
          src="/WhatIsBeardiface.html"
          height="600"
        />
      </Dialog>
      <Dialog open={aboutOpen} onClose={() => setAboutOpen(false)}>
        <DialogContent>
          <iframe title="About" src="/About.html" height="100" />
        </DialogContent>
      </Dialog>
    </>
  );
}
